import { Controller } from '@hotwired/stimulus'

/*
 * Litigant Messaging — AttachmentPreviewController
 * Scaffold registered in Task 4. Implementation in Task 14.
 */
export default class extends Controller {
    connect() {}
}
